exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width{width:100%}.align-right{justify-content:flex-end}\n", ""]);

// exports
